import { render, staticRenderFns } from "./Gribb1.vue?vue&type=template&id=7059db85&scoped=true"
import script from "./Gribb1.vue?vue&type=script&lang=js"
export * from "./Gribb1.vue?vue&type=script&lang=js"
import style0 from "./Gribb1.vue?vue&type=style&index=0&id=7059db85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7059db85",
  null
  
)

export default component.exports